import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { GetMyProfileResponse, UpdateMyProfileRequest } from '../../types/auth.js'

import { apiClient } from '../../lib/client.js'
import { meKeys } from './keys.js'

export const useUpdateMyProfileMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateMyProfileRequest) => {
      const response = await apiClient.client.put<GetMyProfileResponse>('/me/profile', data)
      return response.data
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: meKeys.profile })
      queryClient.invalidateQueries({ queryKey: meKeys.me })
    },
    onMutate: async (data) => {
      await queryClient.cancelQueries({ queryKey: meKeys.profile })

      const previousProfile = queryClient.getQueryData<GetMyProfileResponse>(meKeys.profile)

      if (previousProfile) {
        queryClient.setQueryData<GetMyProfileResponse>(meKeys.profile, {
          ...previousProfile,
          client: previousProfile.client
            ? {
                ...previousProfile.client,
                birthDate: data.birthDate ?? previousProfile.client.birthDate,
                gender: data.gender ?? previousProfile.client.gender,
              }
            : null,
          user: {
            ...previousProfile.user,
            firstName: data.firstName,
            lastName: data.lastName,
          },
        })
      }

      return { previousProfile }
    },
  })
}
